import styled from 'styled-components';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchButton = styled(Flex)<{ radius: number }>`
  gap: 6px;
  padding: 5px 8px;
  cursor: pointer;
  user-select: none;
  background: #ebf8f3;
  border: 1px solid #ebf8f3;

  img {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
  }

  img.open {
    transform: rotate(180deg);
  }

  border-radius: ${({ radius }) => radius}px;
`;

export const MenuText = styled.div`
  display: flex;
  flex: 1;

  span {
    font-size: 14px;
    line-height: 19px;
    color: #00a86b;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 190px;
  }
`;
